module.exports = __webpack_public_path__ + "img/woman.98e86981.png";